import { Venue } from './types'
import { VenueAction } from './actions'

export interface State {
  venues?: Venue[]
  pending: boolean
  error: boolean
}

export const initialState: State = {
  venues: undefined,
  pending: true,
  error: false
}

export default (state = initialState, action: VenueAction): State => {
  switch (action.type) {
    case 'venue.fetch':
      return {
        ...state,
        pending: true,
        venues: undefined,
        error: false
      }
    case 'venue.fetchFail':
      return {
        ...state,
        pending: false,
        error: true
      }

    case 'venue.addVenue':
      let items: Venue[] = []

      if ('payload' in action) {
        items = action.payload ?? []
      }

      if (!state.venues) {
        return {
          ...state,
          venues: items
        }
      }

      return {
        ...state,
        venues: items
      }

    default:
      return state
  }
}
